export const Surat = {
    title: "Surat",
    title1: "(Diamond)",
        attractions: [
            {
                name: "Dumas Beach",
                description: "Dumas Beach is a popular beach located near Surat, known for its black sand and serene atmosphere. It is a favorite spot for locals and tourists to relax, enjoy the sunset, and indulge in street food. The beach is also famous for its spooky legends and is believed to be haunted, adding an element of mystery to its charm.",
                location: "Dumas Beach Road, Dumas, Surat, Gujarat",
                timings: "Open 24 hours",
                ticket: "Free Entry",
                bestTimeToVisit: "Evening for sunset views",
                activities: [
                    "Enjoy the black sand and serene views",
                    "Try local street food like pav bhaji and chai",
                    "Take a peaceful walk along the shore",
                    "Experience the spooky legends and stories",
                    "Capture stunning sunset photographs"
                ],
                mapLink: "https://maps.app.goo.gl/PmMijMY7XKM4Tp2F9", // Replace with a valid Google Maps link
            },
            {
                name: "Sarthana Nature Park",
                description: "Sarthana Nature Park is a lush green park and zoo located in Surat, offering a perfect escape into nature. It is home to a variety of animals, birds, and reptiles, along with beautifully landscaped gardens. The park is ideal for families, nature lovers, and those seeking a peaceful retreat.",
                location: "Sarthana, Surat, Gujarat",
                timings: "9:00 AM to 6:00 PM",
                ticket: "₹20 for adults, ₹10 for children",
                bestTimeToVisit: "Morning or late afternoon",
                activities: [
                    "Explore the zoo and see animals like lions, tigers, and deer",
                    "Walk through the lush green gardens",
                    "Enjoy a picnic with family and friends",
                    "Visit the butterfly park and aviary",
                    "Take photographs of the scenic surroundings"
                ],
                mapLink: "https://maps.app.goo.gl/MQzGt7VZ5DrZTAQf8", // Replace with a valid Google Maps link
            },
            {
                name: "Jagdishchandra Bose Aquarium",
                description: "Jagdishchandra Bose Aquarium is one of the oldest aquariums in India, located in Surat. It houses a wide variety of marine life, including colorful fish, turtles, and other aquatic creatures. The aquarium is a great place for kids and families to learn about marine biodiversity.",
                location: "Athwa, Surat, Gujarat",
                timings: "10:00 AM to 8:00 PM",
                ticket: "₹10 for adults, ₹5 for children",
                bestTimeToVisit: "Afternoon",
                activities: [
                    "Explore the diverse marine life",
                    "Learn about aquatic ecosystems",
                    "Take kids for an educational outing",
                    "Capture photos of colorful fish and turtles",
                    "Enjoy the peaceful ambiance"
                ],
                mapLink: "https://maps.app.goo.gl/jXr2NNMnpMrBLf4X6", // Replace with a valid Google Maps link
            },
            {
                name: "Dutch Garden",
                description: "Dutch Garden is a historical garden located in Surat, built during the Dutch colonial era. It features beautiful architecture, lush greenery, and a serene atmosphere. The garden is a great place for history enthusiasts and those looking for a peaceful stroll.",
                location: "Magdalla, Surat, Gujarat",
                timings: "8:00 AM to 6:00 PM",
                ticket: "Free Entry",
                bestTimeToVisit: "Morning or evening",
                activities: [
                    "Explore the Dutch-era architecture",
                    "Take a peaceful walk in the garden",
                    "Capture photographs of the historical structures",
                    "Enjoy the serene ambiance",
                    "Learn about the Dutch influence in Surat"
                ],
                mapLink: "https://maps.app.goo.gl/NXHNFreoXeYcBVek7", // Replace with a valid Google Maps link
            },
            {
                name: "Gopi Talav",
                description: "Gopi Talav is a historic lake and garden located in Surat, known for its beautiful surroundings and peaceful ambiance. It is a great place for a family outing or a relaxing evening stroll.",
                location: "Gopipura, Surat, Gujarat",
                timings: "8:00 AM to 8:00 PM",
                ticket: "Free Entry",
                bestTimeToVisit: "Evening",
                activities: [
                    "Take a walk around the lake",
                    "Enjoy the lush green surroundings",
                    "Capture photographs of the scenic views",
                    "Spend quality time with family",
                    "Relax and unwind in the peaceful ambiance"
                ],
                mapLink: "https://maps.app.goo.gl/a3MjgXmU6nUQFq7D7", // Replace with a valid Google Maps link
            },
            {
                name: "Science Center",
                description: "The Science Center in Surat is an interactive museum designed to make learning about science fun and engaging. It features hands-on exhibits, a planetarium, and educational displays that cater to both children and adults.",
                location: "City Light Road, Surat, Gujarat",
                timings: "10:00 AM to 6:00 PM",
                ticket: "₹50 for adults, ₹30 for children",
                bestTimeToVisit: "Morning or afternoon",
                activities: [
                    "Explore interactive science exhibits",
                    "Visit the planetarium for a star show",
                    "Participate in educational workshops",
                    "Learn about scientific principles in a fun way",
                    "Take kids for an educational outing"
                ],
                mapLink: "https://maps.app.goo.gl/YdG7kbgn9A7Z6w3M9", // Replace with a valid Google Maps link
            },
            {
                name: "VR Surat Mall",
                description: "VR Surat Mall is one of the largest shopping malls in Surat, offering a wide range of retail stores, entertainment options, and dining experiences. It is a popular destination for shopping, movies, and family outings.",
                location: "Dumas Road, Surat, Gujarat",
                timings: "10:00 AM to 10:00 PM",
                ticket: "Free Entry (Charges apply for activities)",
                bestTimeToVisit: "Evening",
                activities: [
                    "Shop at popular retail stores",
                    "Watch a movie at the multiplex",
                    "Enjoy a meal at the food court",
                    "Visit the indoor gaming zone",
                    "Attend events and exhibitions"
                ],
                mapLink: "https://maps.app.goo.gl/ph3GZycDK9RK8KNDA", // Replace with a valid Google Maps link
            },
            {
                name: "Sneh Rashmi Botanical Garden",
                description: "Sneh Rashmi Botanical Garden is a beautifully landscaped garden in Surat, featuring a wide variety of plants, flowers, and trees. It is a perfect place for nature lovers and those seeking a peaceful retreat.",
                location: "Sarthana, Surat, Gujarat",
                timings: "9:00 AM to 6:00 PM",
                ticket: "₹10 for adults, ₹5 for children",
                bestTimeToVisit: "Morning or evening",
                activities: [
                    "Take a walk through the lush gardens",
                    "Admire the variety of plants and flowers",
                    "Capture photographs of the scenic beauty",
                    "Enjoy a picnic with family and friends",
                    "Relax in the peaceful ambiance"
                ],
                mapLink: "https://maps.app.goo.gl/8ApWqZGCDKg5dEpq6", // Replace with a valid Google Maps link
            },
            {
                name: "Tapi Riverfront",
                description: "The Tapi Riverfront is a picturesque promenade along the Tapi River in Surat. It offers stunning views of the river, beautifully landscaped gardens, and recreational facilities for visitors.",
                location: "Athwa, Surat, Gujarat",
                timings: "6:00 AM to 10:00 PM",
                ticket: "Free Entry",
                bestTimeToVisit: "Evening for sunset views",
                activities: [
                    "Take a stroll along the riverfront",
                    "Enjoy the scenic views of the Tapi River",
                    "Capture photographs of the sunset",
                    "Relax in the gardens",
                    "Attend cultural events and festivals"
                ],
                mapLink: "https://maps.app.goo.gl/rqv5FEVTKdjV7ANM9", // Replace with a valid Google Maps link
            },
            {
                name: "Ambika Niketan Temple",
                description: "Ambika Niketan Temple is a beautiful and serene temple dedicated to Goddess Ambika. It is known for its stunning architecture and spiritual ambiance, attracting devotees and tourists alike.",
                location: "Udhna, Surat, Gujarat",
                timings: "6:00 AM to 8:00 PM",
                ticket: "Free Entry",
                bestTimeToVisit: "Morning or evening",
                activities: [
                    "Seek blessings at the temple",
                    "Admire the temple's architecture",
                    "Participate in religious rituals",
                    "Enjoy the peaceful ambiance",
                    "Attend special festivals and events"
                ],
                mapLink: "https://maps.app.goo.gl/M6exSp4sfQF7nMLT9", // Replace with a valid Google Maps link
            },
            {
                name: "Chintamani Jain Temple",
                description: "Chintamani Jain Temple is a historic Jain temple located in Surat, known for its intricate carvings and spiritual significance. It is a place of worship and a symbol of Jain heritage.",
                location: "Mughal Sarai, Surat",
                timings: "6:00 AM to 8:00 PM",
                ticket: "Free Entry",
                bestTimeToVisit: "Morning or evening",
                activities: [
                    "Seek blessings at the temple",
                    "Admire the intricate carvings and architecture",
                    "Learn about Jainism and its teachings",
                    "Enjoy the peaceful ambiance",
                    "Attend religious ceremonies"
                ],
                mapLink: "https://maps.app.goo.gl/ZUAPuXD7DJgPGBmd6", // Replace with a valid Google Maps link
            },
            {
                name: "Vansda National Park",
                description: "Vansda National Park is a lush green forest located near Surat, home to a variety of flora and fauna. It is a great place for nature lovers and wildlife enthusiasts.",
                location: "Vansda, Navsari District, Gujarat",
                timings: "8:00 AM to 5:00 PM",
                ticket: "₹50 for adults, ₹20 for children",
                bestTimeToVisit: "Morning",
                activities: [
                    "Explore the dense forest and wildlife",
                    "Spot animals like leopards, deer, and monkeys",
                    "Take a guided nature walk",
                    "Capture photographs of the natural beauty",
                    "Enjoy a peaceful retreat in nature"
                ],
                mapLink: "https://maps.app.goo.gl/K9fprArwkWGHoPvHA", // Replace with a valid Google Maps link
            },
            {
                name: "Suvali Beach",
                description: "Suvali Beach is a serene and less crowded beach located near Surat. It is known for its clean sands, clear waters, and peaceful ambiance, making it a perfect spot for relaxation.",
                location: "Hazira, Surat, Gujarat",
                timings: "Open 24 hours",
                ticket: "Free Entry",
                bestTimeToVisit: "Evening for sunset views",
                activities: [
                    "Relax on the clean sandy beach",
                    "Enjoy the clear waters",
                    "Capture photographs of the sunset",
                    "Take a peaceful walk along the shore",
                    "Enjoy a quiet retreat away from the crowds"
                ],
                mapLink: "https://maps.app.goo.gl/M1JJeNHPWDYw8sV37", // Replace with a valid Google Maps link
            },
            {
                name: "ISKCON Temple Surat",
                description: "ISKCON Temple in Surat is a beautiful temple dedicated to Lord Krishna. It is known for its spiritual ambiance, devotional songs, and delicious vegetarian food served at the temple canteen.",
                location: "Mota Varachha, Surat, Gujarat",
                timings: "4:30 AM to 8:30 PM",
                ticket: "Free Entry",
                bestTimeToVisit: "Morning or evening",
                activities: [
                    "Seek blessings at the temple",
                    "Participate in devotional songs and prayers",
                    "Enjoy the vegetarian food at the canteen",
                    "Attend spiritual discourses",
                    "Experience the peaceful ambiance"
                ],
                mapLink: "https://maps.app.goo.gl/AC72eeDVESFqLhcM8", // Replace with a valid Google Maps link
            },
            {
                name: "Modi Resort",
                description: "Modi Resort is a popular recreational spot in Surat, offering a variety of activities for families and friends. It features water rides, amusement parks, and lush green surroundings.",
                location: "Sachin, Surat, Gujarat",
                timings: "10:00 AM to 7:00 PM",
                ticket: "₹500 per person",
                bestTimeToVisit: "Weekends or holidays",
                activities: [
                    "Enjoy water rides and slides",
                    "Explore the amusement park",
                    "Have a picnic in the lush green surroundings",
                    "Capture fun photographs",
                    "Spend a fun-filled day with family and friends"
                ],
                mapLink: "https://maps.app.goo.gl/vzAa4vpZnn4bYsbf9", // Replace with a valid Google Maps link
            },
            {
                name: "Snow Park",
                description: "Snow Park in Surat is an indoor snow-themed park where visitors can experience snowfall and enjoy various snow activities. It is a fun destination for families and kids.",
                location: "VR Surat Mall, Dumas Road, Surat",
                timings: "11:00 AM to 9:00 PM",
                ticket: "₹600 per person",
                bestTimeToVisit: "Afternoon",
                activities: [
                    "Experience snowfall in a controlled environment",
                    "Enjoy snow slides and rides",
                    "Build snowmen and play in the snow",
                    "Capture fun photographs",
                    "Have a unique winter experience"
                ],
                mapLink: "https://maps.app.goo.gl/TfCCAxogXWBYsUvi9", // Replace with a valid Google Maps link
            },
            {
                name: "Amaazia Water Park",
                description: "Amaazia Water Park is one of the largest water parks in Surat, offering a variety of water rides, wave pools, and entertainment options. It is a perfect destination for a fun-filled day with family and friends.",
                location: "Dumas Road, Surat, Gujarat",
                timings: "10:00 AM to 6:00 PM",
                ticket: "₹1000 per person",
                bestTimeToVisit: "Weekends or holidays",
                activities: [
                    "Enjoy thrilling water rides",
                    "Relax in the wave pool",
                    "Have fun at the kids' play area",
                    "Capture fun photographs",
                    "Spend a fun-filled day with family and friends"
                ],
                mapLink: "https://maps.app.goo.gl/ENABD2RtcT7HoN7f9", // Replace with a valid Google Maps link
            },
            {
                name: "Mughal Sarai",
                description: "Mughal Sarai is a historical monument located in Surat, built during the Mughal era. It served as a resting place for travelers and is known for its architectural beauty.",
                location: "Rander, Surat, Gujarat",
                timings: "8:00 AM to 6:00 PM",
                ticket: "Free Entry",
                bestTimeToVisit: "Morning or evening",
                activities: [
                    "Explore the Mughal-era architecture",
                    "Learn about the history of the monument",
                    "Capture photographs of the structure",
                    "Enjoy the peaceful ambiance",
                    "Visit nearby attractions"
                ],
                mapLink: "https://maps.app.goo.gl/w7W2SZCPgQmRUPoWA", // Replace with a valid Google Maps link
            },
            {
                name: "Surat Castle",
                description: "Surat Castle is a historic fort built by the British in the 16th century. It is a symbol of Surat's rich history and offers a glimpse into the city's past.",
                location: "Surat Fort Road, Surat, Gujarat",
                timings: "9:00 AM to 5:00 PM",
                ticket: "₹20 for adults, ₹10 for children",
                bestTimeToVisit: "Morning or afternoon",
                activities: [
                    "Explore the historic fort",
                    "Learn about Surat's history",
                    "Capture photographs of the architecture",
                    "Enjoy the panoramic views from the fort",
                    "Visit nearby attractions"
                ],
                mapLink: "https://maps.app.goo.gl/4LWt5sxDudQ2ja7w9", // Replace with a valid Google Maps link
            }
        ]
    };